import { AreaFilterMapper } from "@app/routing/mappers/AreaFilterMapper";
import { AttendanceFilterMapper } from "@app/routing/mappers/AttendanceFilterMapper";
import { ContinentFilterMapper } from "@app/routing/mappers/ContinentFilterMapper";
import { CountryFilterMapper } from "@app/routing/mappers/CountryFilterMapper";
import { CityFilterMapper } from "@app/routing/mappers/CityFilterMapper";
import { DegreeTypeFilterMapper } from "@app/routing/mappers/DegreeTypeFilterMapper";
import { DensitiesFilterMapper } from "@app/routing/mappers/DensitiesFilterMapper";
import { DisciplineFilterMapper } from "@app/routing/mappers/DisciplineFilterMapper";
import { DurationFilterMapper } from "@app/routing/mappers/DurationFilterMapper";
import { EducationalFormFilterMapper } from "@app/routing/mappers/EducationalFormFilterMapper";
import { EducationalLevelFilterMapper } from "@app/routing/mappers/EducationalLevelFilterMapper";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { KeywordFilterMapper } from "@app/routing/mappers/KeywordFilterMapper";
import { OrganisationFilterMapper } from "@app/routing/mappers/OrganisationFilterMapper";
import { SortMapper } from "@app/routing/mappers/SortMapper";
import { SpecialProgrammesFilterMapper } from "@app/routing/mappers/SpecialProgrammesFilterMapper";
import { TuitionFeeFilterMapper } from "@app/routing/mappers/TuitionFeeFilterMapper";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { CampaignTypeMapper } from "@app/routing/mappers/CampaignTypeMapper";
import { SearchType } from "@domain/enums/SearchType";

export const availableFilterMappers: FilterMapper[] = [
	EducationalLevelFilterMapper.getInstance(),
	CountryFilterMapper.getInstance(),
	DisciplineFilterMapper.getInstance(),
	ContinentFilterMapper.getInstance(),
	AreaFilterMapper.getInstance(), //Problematic with region and country together
	CityFilterMapper.getInstance(),
	AttendanceFilterMapper.getInstance(),
	DurationFilterMapper.getInstance(),
	DegreeTypeFilterMapper.getInstance(),
	EducationalFormFilterMapper.getInstance(),
	SpecialProgrammesFilterMapper.getInstance(),
	TuitionFeeFilterMapper.getInstance(),
	DensitiesFilterMapper.getInstance(),
	OrganisationFilterMapper.getInstance(),
	KeywordFilterMapper.getInstance(),
	CampaignTypeMapper.getInstance(),
	SortMapper.getInstance()
];

const ALL_FILTER_TYPES = Object.values(FilterType) as FilterType[];

export const getAllowedFilterTypesForSearchType = (searchType: SearchType): ReadonlySet<FilterType> => {
	if (searchType === SearchType.SCHOLARSHIP_SEARCH) {
		return new Set(ALL_FILTER_TYPES);
	}

	const disallowedFilterTypes = new Set(
		availableFilterMappers
			.filter((mapper) => !mapper.allowedInSearchType(searchType))
			.map((mapper) => mapper.filterType)
	);

	return new Set(ALL_FILTER_TYPES.filter((type) => !disallowedFilterTypes.has(type)));
};

export const isFilterTypeAllowedForSearchType = (filterType: FilterType, searchType: SearchType): boolean => {
	return getAllowedFilterTypesForSearchType(searchType).has(filterType);
};
